(function(){
  function initHostClub(){
    var root=document.querySelector('[data-root-host-club]');
    if(!root||root.getAttribute('data-ready')==='true')return;
    root.setAttribute('data-ready','true');

    var max=3;
    var order=['pineapple','strawberry','grapefruit','pomegranate'];
    var state={pineapple:0,strawberry:0,grapefruit:0,pomegranate:0};
    var cadence='6';
    var cards=Array.prototype.slice.call(root.querySelectorAll('[data-flavor-card]'));
    var count=root.querySelector('[data-selection-count]');
    var progress=root.querySelector('[data-selection-progress]');
    var slots=Array.prototype.slice.call(root.querySelectorAll('[data-summary-slot]'));
    var cta=root.querySelector('[data-bundle-cta]');
    var status=root.querySelector('[data-builder-status]');
    var handoff=root.querySelector('.rhost__handoff');
    var cadenceButtons=Array.prototype.slice.call(root.querySelectorAll('[data-cadence]'));
    var flavorMeta={};
    var checkoutConfig=window.RootHostClubCheckoutConfig||{};
    var isSubmitting=false;
    var hero=root.querySelector('.rhost__hero');
    var builder=root.querySelector('#host-club-builder');
    if(hero&&builder&&hero.nextElementSibling!==builder)hero.insertAdjacentElement('afterend',builder);

    cards.forEach(function(card){
      flavorMeta[card.getAttribute('data-flavor')]={
        name:card.getAttribute('data-name')||'',
        image:card.getAttribute('data-image')||''
      };
    });

    var announcement=root.querySelector('.rhost__announcement');
    var micro=root.querySelector('.rhost__micro');
    var heroTitle=root.querySelector('.rhost__hero-copy .rhost__display');
    var heroBody=root.querySelector('.rhost__hero-copy > p:not(.rhost__eyebrow):not(.rhost__micro)');
    var benefits=root.querySelectorAll('.rhost__benefits li');
    if(announcement)announcement.textContent='Save 10% every Host Club refill · Free shipping · Skip, swap or delay anytime';
    if(heroTitle)heroTitle.innerHTML='Your bar cart,<br><span>kept stocked.</span>';
    if(heroBody)heroBody.textContent='Choose any 3 four-packs. Save 10% every refill. Delivered every 6 or 8 weeks. Skip, swap or delay anytime.';
    if(micro)micro.textContent='Free shipping on every Host Club refill.';
    if(benefits[0])benefits[0].textContent='Save 10% every refill';
    if(benefits[1])benefits[1].textContent='Free shipping';
    if(benefits[2])benefits[2].textContent='Skip, swap or delay anytime';

    if(handoff)handoff.textContent='Your exact mix and refill schedule will carry into secure checkout.';
    if(cta&&!root.querySelector('[data-checkout-proof]')){
      var proof=document.createElement('p');
      proof.className='rhost__checkout-proof';
      proof.setAttribute('data-checkout-proof','');
      proof.textContent='Secure checkout · Save 10% · Free shipping · Skip, swap or delay anytime';
      cta.insertAdjacentElement('afterend',proof);
    }

    function total(){return order.reduce(function(sum,key){return sum+state[key]},0)}
    function selectedList(){
      var list=[];
      order.forEach(function(key){for(var i=0;i<state[key];i++)list.push(key)});
      return list;
    }
    function selectedNames(){
      return selectedList().map(function(key){return flavorMeta[key]&&flavorMeta[key].name?flavorMeta[key].name:key});
    }
    function announce(message){if(status)status.textContent=message}
    function readyCtaText(){return 'Continue to checkout'}

    function render(message){
      var current=total();
      var ready=current===max;
      if(count)count.textContent=current+' of '+max+' four-packs selected';
      if(progress)progress.style.width=Math.min(100,(current/max)*100)+'%';

      cards.forEach(function(card){
        var key=card.getAttribute('data-flavor');
        var qty=state[key]||0;
        var qtyNode=card.querySelector('[data-qty]');
        var minus=card.querySelector('[data-action="minus"]');
        var plus=card.querySelector('[data-action="plus"]');
        if(qtyNode)qtyNode.textContent=qty;
        if(minus)minus.disabled=qty===0;
        if(plus)plus.disabled=current>=max||card.getAttribute('data-available')==='false';
        card.classList.toggle('is-selected',qty>0);
      });

      var picks=selectedList();
      slots.forEach(function(slot,index){
        var key=picks[index];
        var image=slot.querySelector('img');
        var label=slot.querySelector('[data-slot-label]');
        if(key&&flavorMeta[key]){
          slot.classList.remove('is-empty');
          if(image){image.src=flavorMeta[key].image;image.alt=flavorMeta[key].name+' four-pack'}
          if(label)label.textContent=flavorMeta[key].name;
        }else{
          slot.classList.add('is-empty');
          if(image){image.removeAttribute('src');image.alt=''}
          if(label)label.textContent='Choose a four-pack';
        }
      });

      if(cta&&!isSubmitting){
        cta.setAttribute('aria-disabled',ready?'false':'true');
        cta.classList.toggle('is-ready',ready);
        cta.textContent=ready?readyCtaText():'Choose '+(max-current)+' more '+(max-current===1?'four-pack':'four-packs');
      }

      if(message){
        announce(message);
      }else if(status){
        if(ready){
          var displayPrice=checkoutConfig.formattedPrice?' · '+checkoutConfig.formattedPrice:'';
          status.textContent='Your box is ready · 12 cans'+displayPrice+' · save 10% + free shipping.';
        }else{
          status.textContent='Choose any three 4-packs to continue.';
        }
      }
    }

    function resetSubmitting(message){
      isSubmitting=false;
      if(cta){
        cta.classList.remove('is-loading');
        cta.removeAttribute('aria-busy');
        cta.setAttribute('aria-disabled',total()===max?'false':'true');
        cta.textContent=total()===max?readyCtaText():'Choose '+(max-total())+' more '+((max-total())===1?'four-pack':'four-packs');
      }
      if(message)announce(message);
    }

    function addHidden(form,name,value){
      var input=document.createElement('input');
      input.type='hidden';
      input.name=name;
      input.value=value==null?'':String(value);
      form.appendChild(input);
    }

    function submitSubscriptionToCart(planId,names){
      var form=document.createElement('form');
      form.method='post';
      form.action='/cart/add';
      form.style.display='none';
      addHidden(form,'id',checkoutConfig.variantId);
      addHidden(form,'quantity','1');
      addHidden(form,'selling_plan',planId);
      addHidden(form,'properties[Your mix]',names.join(' + '));
      addHidden(form,'properties[Refill schedule]','Every '+cadence+' weeks');
      addHidden(form,'return_to','/cart');
      document.body.appendChild(form);
      form.submit();
    }

    function beginCheckout(){
      var picks=selectedList();
      var planId=checkoutConfig.plans&&checkoutConfig.plans[cadence];
      if(picks.length!==max){
        render('Choose exactly three four-packs before continuing.');
        return;
      }
      if(!checkoutConfig.variantId||!planId){
        render('Checkout is temporarily unavailable. Please refresh and try again.');
        return;
      }
      if(isSubmitting)return;

      isSubmitting=true;
      if(cta){
        cta.classList.add('is-loading');
        cta.setAttribute('aria-busy','true');
        cta.setAttribute('aria-disabled','true');
        cta.textContent='Adding your box…';
      }
      announce('Saving your box and subscription details…');

      var names=selectedNames();
      try{
        sessionStorage.setItem('rootHostClubPlan',JSON.stringify({choices:picks,cadence:cadence,createdAt:new Date().toISOString()}));
      }catch(error){}

      try{
        submitSubscriptionToCart(planId,names);
      }catch(error){
        console.error('Host Club cart handoff failed:',error);
        resetSubmitting('We couldn’t add your box to the cart. Please try again.');
      }
    }

    root.addEventListener('click',function(event){
      var action=event.target.closest('[data-action]');
      if(action){
        var card=action.closest('[data-flavor-card]');
        if(!card)return;
        var key=card.getAttribute('data-flavor');
        var direction=action.getAttribute('data-action');
        if(direction==='plus'&&total()<max&&card.getAttribute('data-available')!=='false'){
          state[key]++;
          render(flavorMeta[key].name+' added. '+(total()===max?'Your box is ready.':total()+' of '+max+' selected.'));
        }
        if(direction==='minus'&&state[key]>0){
          state[key]--;
          render(flavorMeta[key].name+' removed. '+total()+' of '+max+' selected.');
        }
        return;
      }

      var preset=event.target.closest('[data-preset]');
      if(preset){
        var keys=(preset.getAttribute('data-preset')||'').split(',').filter(Boolean);
        order.forEach(function(key){state[key]=0});
        keys.slice(0,max).forEach(function(key){if(Object.prototype.hasOwnProperty.call(state,key))state[key]++});
        render('Suggested mix loaded. You can still swap any four-pack.');
        return;
      }

      var clear=event.target.closest('[data-clear-builder]');
      if(clear){
        order.forEach(function(key){state[key]=0});
        render('Your Host Club box is clear.');
        return;
      }

      var cadenceButton=event.target.closest('[data-cadence]');
      if(cadenceButton){
        cadence=cadenceButton.getAttribute('data-cadence');
        cadenceButtons.forEach(function(button){button.setAttribute('aria-pressed',button===cadenceButton?'true':'false')});
        render('Delivery set to every '+cadence+' weeks.');
        return;
      }

      var link=event.target.closest('[data-bundle-cta]');
      if(link){
        event.preventDefault();
        if(total()!==max){
          render('Choose exactly three four-packs before continuing.');
          var firstAvailable=cards.find(function(card){return card.getAttribute('data-available')!=='false'});
          if(firstAvailable)firstAvailable.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'center'});
          return;
        }
        beginCheckout();
      }
    });

    Array.prototype.slice.call(root.querySelectorAll('[data-host-faq] details')).forEach(function(detail){
      detail.addEventListener('toggle',function(){
        if(!detail.open)return;
        Array.prototype.slice.call(root.querySelectorAll('[data-host-faq] details')).forEach(function(other){if(other!==detail)other.open=false});
      });
    });

    render();
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initHostClub);else initHostClub();
  document.addEventListener('shopify:section:load',initHostClub);
})();
